<template>
  <div class="wallet">
    <div class="container">
      <div class="nav-head">
        <div class="left">
          <span :class="nav==0?'active':''" @click="toNav(0)">钱包明细</span>
          <span :class="nav==1?'active':''" @click="toNav(1)">提现明细</span>
        </div>
        <div class="right">
          <span class="tip" @click="smDialogVisible = true">提现说明 <i class="fa fa-question-circle-o" aria-hidden="true"></i></span>
          <span>
            钱包余额：
            <span class="cols">{{memberInfo.accountBalance || '0'}}</span>
          </span>
          <span class="withdrawal" @click="toWithdraw">立即提现</span>
        </div>
      </div>
      <!-- 钱包明细 -->
      <div class="list" v-if="nav==0">
        <div class="item head">
          <!-- <span>类型</span> -->
          <span>变动前(元)</span>
          <span>变动(元)</span>
          <span>变动后(元)</span>
          <span>时间</span>
        </div>
        <div class="item content" v-for="(item,index) in walletKindList" :key="index">
          <!-- <span>消费</span> -->
          <span>{{item.walletBeforeMoney}}</span>
          <span class="col">{{item.walletBeforeMoney - item.walletAfterMoney}}</span>
          <span>{{item.walletAfterMoney}}</span>
          <span>{{fomateDate(item.createDate)}}</span>
        </div>
      </div>

      <!-- 提现明细 -->
      <div class="list" v-if="nav==1">
        <div class="item head">
          <span>余额(元)</span>
          <span>提现金额(元)</span>
          <span>申请状态</span>
          <span>发放状态</span>
          <span>时间</span>
          <span>操作</span>
        </div>
        <div class="item content" v-for="(item,index) in depositeKindList" :key="index">
          <span>{{item.balanceMoney}}</span>
          <span class="col">{{item.money}}</span>
          <span class="cols">{{auditStatus(parseInt(item.auditStatus))}}</span>
          <span class="cols">{{parseInt(item.paymentStatus) ? '已发放' : '未发放'}}</span>
          <span>{{item.paymentTime}}</span>
          <span @click="toDetail(item.id)">
            <span class="btn">查看</span>
          </span>
        </div>
      </div>

      <el-pagination
        class="my-pagination"
        background
        layout="prev, pager, next"
        :total="nav ? depositeList.total : walletMessage.total"
        :page-size="nav ? depositeList.pageSize : walletMessage.pageSize"
        @current-change="handleCurrentChange">
      </el-pagination>

      <!--提现明细详情弹框-->
      <el-dialog
        class="my-dialog"
        title="提现明细"
        :visible.sync="dialogVisible"
        width="30%">
        <div class="box"  v-loading="detailLoading">
          <div class="item">
            <div class="text">申请时间</div>
            <div class="val">{{fomateDate(depositeDetail.auditDate)}}</div>
          </div>
          <div class="item">
            <div class="text">提现前余额</div>
            <div class="val">{{depositeDetail.balanceMoney}}元</div>
          </div>
          <div class="item">
            <div class="text">申请人手机号</div>
            <div class="val">{{depositeDetail.memberPhone}}</div>
          </div>
          <div class="item">
            <div class="text">提现金额</div>
            <div class="val">{{depositeDetail.money}}</div>
          </div>
          <div class="item">
            <div class="text">审核状态</div>
            <div class="val cols">{{auditStatus(parseInt(depositeDetail.auditStatus))}}</div>
          </div>
          <div class="item">
            <div class="text">发送状态</div>
            <div class="val cols">{{parseInt(depositeDetail.paymentStatus) ? '已发放' : '未发放'}}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button round size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      
      <!--提现操作弹框-->
      <el-dialog
        class="withdrawal-dialog"
        :visible.sync="withdrawalVisible"
        width="30%"
        :before-close="handleClose">
        <div v-loading="withdrawal.loading">
          <!-- <div class="head"></div> -->
          <img class="head" :src="memberInfo.headPicPath" alt="">
          <div class="name">{{memberInfo.name}}</div>
          <div class="balance">余额 ￥{{memberInfo.accountBalance || '0'}}</div>
          <div class="info">
            <span>提现金额</span>
            <input class="money" 
                   v-model="withdrawal.money" 
                   type="text" 
                   placeholder="请输入提现金额" @blur="clearNoNum">
            <span class="yuan">元</span>
          </div>
          <div class="info">
            <span>真实姓名</span>
            <input type="text" v-model="withdrawal.name" placeholder="请输入真实姓名">
          </div>
          <div class="click" @click="toWithdrawalSubmit">提现</div>
        </div>
      </el-dialog>

      <!--提现说明弹框-->
      <el-dialog
        title="提现说明"
        :visible.sync="smDialogVisible"
        width="30%">
        <!-- <span>这是一段信息</span> -->
        <div v-html="statementOfWithdrawal"></div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="smDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";

import axios from "axios";
import qs from "qs";

import { fomateDate } from "@/util/util.js";

export default {
  name: "wallet",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],

      walletMessage:{
        total:0,
        currentPage: 1,
        pageSize: 10,
        list:[]
      },
      depositeList:{
        total:0,
        currentPage: 1,
        pageSize: 10,
        list:[]
      },
      depositeDetail:{},

      dialogVisible: false,
      detailLoading: false,
      withdrawalVisible: false,

      withdrawal:{
        money: null,
        name: null,
        loading: false
      },

      smDialogVisible: false
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    walletKindList(){
      return this.walletMessage.list[this.walletMessage.currentPage -1];
    },
    depositeKindList(){
      return this.depositeList.list[this.depositeList.currentPage -1];
    },
    auditStatus(tag){
      return function(tag){
        switch(tag){
          case 0:
            return '未审核';
            break;
          case 1:
            return '通过';
            break;
          case 2:
            return '未通过';
            break;
          default: '';
        }
      }
    },
    // accountBalance(){
    //   return this.$store.state.touristInfo.accountBalance || '0' ;
    // },
    memberInfo() {
      return this.$store.state.memberInfo;
    },
    statementOfWithdrawal(){
      return this.$store.state.webInfo.statementOfWithdrawal;
    }
  },
  methods: {
    fomateDate,

    toNav(index) {
      this.nav = index;

      if(index === 1 && this.depositeList.list.length === 0){
        this.getDepositeList(1,10).then(res => {
          if(res.data.success){
            this.depositeList.total = res.data.output.total;
            this.depositeList.list.push(res.data.output.content);
          }
        });
      }
    },
    getNav(index) {
      this.nav = index;
    },
    handleCurrentChange(val) {
      if(this.nav === 0){
        this.walletMessage.currentPage = val;
        const pageSize = this.walletMessage.pageSize;
        const list = this.walletMessage.list;

        this.getWalletMessage(val,pageSize).then(res => {
          this.walletMessage.total = res.data.total;

          if(res.data.success && res.data.output.list){
            for(let i = 1; i < val ; i++){ //填充空元素
              if(!list[i]){
                list.push(1);
              }
            }
            list.splice(val - 1,val,res.data.list);
          }
        })
      }else if(this.nav === 1){
        this.depositeList.currentPage = val;
        const pageSize = this.depositeList.pageSize;
        const list = this.depositeList.list;

        this.getDepositeList(val,pageSize).then(res => {
          this.depositeList.total = res.data.total;

          if(res.data.success && res.data.output.list){
            for(let i = 1; i < val ; i++){ //填充空元素
              if(!list[i]){
                list.push(1);
              }
            }
            list.splice(val - 1,val,res.data.list);
          }
        })
      }

    },
    getDepositeList(pageNumber,pageSize){
      return  axios
                .get('/mobile/wallet/depositeList.jhtml',{
                  params:{
                    pageNumber,
                    pageSize
                  }
                })
        // .then(res => {
        //   if(res.data.success){
        //     this.depositeList.total = res.data.output.total;
        //     this.depositeList.list.push(res.data.output.content);
        //   }
        // })
    },
    getWalletMessage(pageNumber,pageSize){
      return axios
              .get('/mobile/wl_wallet_detail/getWalletDetail.jhtml',{
                params:{
                  pageNumber,
                  pageSize
                }
              })
        // .then(res => {
        //   // console.log(res.data.success);
        //   if(res.data.success){
        //     this.walletMessage.total = res.data.output.total;
        //     this.walletMessage.list.push(res.data.output.list);
        //   }
        // })
    },
    getDepositeDetail(id){
      axios
        .get('/mobile/wallet/getdeposite.jhtml',{
          params:{
            id
          }
        })
        .then(res => {
          if(res.data.success){
            this.depositeDetail = res.data.output;
            this.detailLoading = false;
          }
        })
    },
    toDetail(id){
      this.dialogVisible = true;
      this.detailLoading = true;
      this.getDepositeDetail(id);
      // console.log(typeof id);
    },
    toWithdrawalSubmit(){
      if(this.withdrawal.money && this.withdrawal.name){
        if(!this.withdrawal.loading){
          this.withdrawal.loading = true;

          if(parseFloat(this.withdrawal.money) > this.withdrawal.maxAmount ){
            this.$message({
              message: `金额不能高于${this.withdrawal.maxAmount}元`,
              type: "error",
              duration: 1000,
              center: true
            });
            this.withdrawal.loading = false;
          }else if(parseFloat(this.withdrawal.money) < this.withdrawal.minAmount){
            this.$message({
              message: `金额不能低于${this.withdrawal.minAmount}元`,
              type: "error",
              duration: 1000,
              center: true
            });
            this.withdrawal.loading = false;
          }else if(parseFloat(this.withdrawal.accountBalance) < this.withdrawal.minAmount){
             this.$message({
              message: `余额不足${this.withdrawal.minAmount}元 , 无法提现`,
              type: "error",
              duration: 1500,
              center: true
            });
            this.withdrawal.loading = false;
          }else {
            axios
              .post(
                "/mobile/wallet/createtbDeposite.jhtml",
                qs.stringify({
                  name: this.withdrawal.name,
                  amounts: this.withdrawal.money,
                })
              )
              .then((res) => {
                if (res.data.success == true) {
                  this.$message({
                    message: `提现成功`,
                    type: "success",
                    duration: 1000,
                    center: true
                  });
                } else {
                  this.$message({
                    message: `${res.data.errorReason}`,
                    type: "error",
                    duration: 1000,
                    center: true
                  });
                }

                // this.withdrawal.loading = false;
                this.handleClose();
              })
              .catch((e) => {
                this.withdrawal.loading = false;
                this.$message({
                  message: "提现失败！",
                  type: "error",
                  duration: 1000,
                  center: true
                });
              });
          }
        }
      }else{
        this.$message({
          message: "请填写完整信息",
          type: "error",
          duration: 500,
          center: true
        });
      }
    },
    //金额输入格式校验
    clearNoNum() {
      if(this.withdrawal.money){
        this.withdrawal.money = this.withdrawal.money.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        this.withdrawal.money = this.withdrawal.money.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        this.withdrawal.money = this.withdrawal.money
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        this.withdrawal.money = this.withdrawal.money.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        if (this.withdrawal.money.indexOf(".") < 0 && this.withdrawal.money != "") {
          //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          this.withdrawal.money = parseFloat(this.withdrawal.money);
        }
      }
    },
    handleClose(){
      this.withdrawal = {
        money: null,
        name: null,
        loading: false
      };
      this.withdrawalVisible = false;
    },
    //提现判断
    toWithdraw() {
      axios
        .get("/mobile/wallet/returnProperties.jhtml")
        .then((res) => {
          if (res.data.output.isWxWallet === "true") {
            if (res.data.output.isWithdrawDeposit) {
              this.withdrawalVisible = true;
              this.withdrawal.accountBalance = res.data.output.member.accountBalance ? res.data.output.member.accountBalance:0;
              this.withdrawal.minAmount = res.data.output.minAmount;
              this.withdrawal.maxAmount = res.data.output.maxAmount;
            } else {
              this.$message({
                message: "当天提现次数超限",
                type: "error",
                duration: 1000,
                center: true
              });
            }

            this.withdrawal.loading = false;
          } else {
              this.$message({
                message: "系统繁忙，请稍后再试~",
                type: "warning",
                duration: 1000,
                center: true
              });

              this.withdrawal.loading = false;
          }
        })
        .catch((e) => {
          this.$message({
            message: "系统繁忙，请稍后再试~",
            type: "warning",
            duration: 1000,
            center: true
          });

          this.withdrawal.loading = false;
        });
    },
  },
  mounted() {},
  created() {
    this.getWalletMessage(1,10).then(res => {
      if(res.data.success){
        this.walletMessage.total = res.data.output.total;
        this.walletMessage.list.push(res.data.output.list);
      }
    });
  }
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 20px;
  padding: 0 60px;
}
.nav-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 14px;
  margin-top: 20px;
}
.left {
  display: flex;
}
.left > span {
  text-align: center;
  display: block;
  width: 80px;
  cursor: pointer;
}
.left > span:nth-child(1) {
  border-right: 1px solid #cccccc;
}
.active {
  color: #258555;
  font-weight: bold;
}
.list {
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 20px;

  min-height: 350px;
}
.item {
  display: flex;
  align-items: center;
  height: 40px;
}
.head {
  background: #f0eeee;
  border-bottom: 1px solid #cccccc;
  font-weight: bold;
}
.item > span {
  text-align: center;
  width: 25%;
  display: block;
}
.content {
  border-bottom: 1px solid #e4e0e0;

  color: #656565;
}
.col {
  color: #5fc96f;
}
.cols {
  color: #e03a3a;
}
.withdrawal {
  display: inline-block;
  font-size: 12px;
  width: 90px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  background: #007741;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 30px;
}
.withdrawal:hover{
  background: #069e5a;
}
.tip {
  margin-right: 30px;
  cursor: pointer;
  color: rgb(0,100,255);
}
.btn {
  font-size: 12px;
  /* border: 1px solid #007741; */
  background: rgb(254, 0, 0);
  color: #fff;
  border-radius: 12px;
  display: inline-block;
  width: 50px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
}
.my-pagination{
  display: inline-block;
  margin: 20px 0;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.my-dialog .item{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.withdrawal-dialog {
  text-align: center;
}
.withdrawal-dialog .head {
  height: 80px;
  width: 80px;
  border-radius: 50%;
}
.withdrawal-dialog .name,
.withdrawal-dialog .balance{
  padding:  4px 0;
  font-size: 14px;
}
.withdrawal-dialog .info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;
  margin: 8px auto;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid #007741;
  font-size: 14px;

  position: relative;
  color: #333;
}
.withdrawal-dialog .info input{
  border: none;
  outline: none;
  height: 100%;
  line-height: 100%;
  font-size: 14px;
}
.withdrawal-dialog .info .yuan{
  position: absolute;
  right: 12px;
}
.withdrawal-dialog .click {
  display: inline-block;
  padding: 4px 24px;
  margin-top: 12px;
  border-radius: 24px;
  background: #007741;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/userview/wallet.vue